import { Component, Inject,Optional,  Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TreeNode } from '@app/shared/_models/common';


@Component({
  selector: 'app-tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class TreeComponent {
  @Input({ required: true }) tree!: TreeNode;
  @Input() selected = new Set<TreeNode>();
  @Input() singleSelect = false;
  @Input() treePrefix = '';
  @Output() selectedChangeEmitter = new EventEmitter<Set<TreeNode>>();

  // constructor(
  //   @Inject(MAT_DIALOG_DATA) public data: any,
  // ) {
  //   this.tree = data.tree;
  //   this.selected = data.selected;
  //   // this.selectedChange = data.selectedChange;
  // }
  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    if (this.data) {
      this.tree = this.data.tree;
      this.selected = this.data.selected;
      if (this.data.singleSelect !== undefined) this.singleSelect = this.data.singleSelect;
      if (this.data.treePrefix !== undefined) this.treePrefix = this.data.treePrefix;
    }
  }

  isChecked(id: number): boolean {
    return Array.from(this.selected).some(n => n.id === id);
  }

  toggleNode(node: TreeNode, checked: boolean) {
    if (checked) {
      if (this.singleSelect) {
        this.selected.forEach(n => {
          if (n.path?.startsWith(this.treePrefix)) this.selected.delete(n);
        });
      }
      this.selected.add(node);
    } else {
      this.selected.delete(node);
      this.selected.forEach(n => {
        if (n.id === node.id) this.selected.delete(n);
      });
    }
    if (this.data) { this.data.selectedChange(this.selected); }
    this.selectedChangeEmitter.emit(this.selected);
  }

  // trackById = (_: number, node: TreeNode) => node.id;
  trackById(index: number, item: { node: { id: number } }): number {
    return item.node.id;
  }

  getFlatNodesWithLevel(root: TreeNode, level = 0): { node: TreeNode, level: number }[] {
    const result: { node: TreeNode, level: number }[] = [{ node: root, level }];
    if (root.children && root.children.length > 0) {
      for (const child of root.children) {
        result.push(...this.getFlatNodesWithLevel(child, level + 1));
      }
    }
    return result;
  }


}
